module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-bg-color-4013813136dfe29a98b55a9be9360f81.png";